<app-top-nav [pageActions]="navActions">
  <div *ngIf="onPC" class="survey-info">
    <span
      class="address-info"
      pTooltip="{{ addressTitle }}"
      tooltipStyleClass="address-tooltip"
      tooltipPosition="bottom"
      showDelay="300"
    >
      <span class="block" *ngIf="fullBlockAddress">
        {{ fullBlockAddress }}
      </span>
      <span *ngIf="fullBlockAddress && address">&nbsp;|&nbsp;</span>
      <span class="full-address" *ngIf="address">
        <span *ngIf="address as fullAddress">{{
          fullAddress?.getFullAddress()
        }}</span>
        <span *ngIf="buildingKey"> &nbsp;|&nbsp;{{ buildingKey }}</span>
      </span>
    </span>

    <span
      class="surveyor-name"
      pTooltip="
            <mat-icon class='material-icons-outlined'> inventory </mat-icon>
            <span class='title' i18n='@@general.assignedsurveyor'>Assigned Surveyor:&nbsp;</span>
            <span>{{ names?.join(' ') }}</span>
        "
      tooltipStyleClass="surveyor-tooltip"
      [escape]="false"
      tooltipPosition="left"
      showDelay="300"
    >
      <mat-icon class="material-icons-outlined"> inventory </mat-icon>
      <span class="initials">{{ initials }}</span>
    </span>

    <div class="kw-logo-wrapper">
      <!-- Needs to be empty -->
    </div>
  </div>
</app-top-nav>
<div class="survey-wrapper">
  <div class="main">
    <ul
      ngbNav
      class="nav-tabs nav-fill mobile-overwrite-tabs"
      [class.portrait]="!showTabTitle"
      [activeId]="tabConfig.activeTabId"
      [destroyOnHide]="tabConfig.destroyOnHide"
      (navChange)="onNavChange($event)"
      #nav="ngbNav"
    >
      <li
        [ngbNavItem]="tabConfig.tabs.valRemarks.id"
        [id]="tabConfig.tabs.valRemarks.id"
        [disabled]="tabConfig.tabs.valRemarks.disabled || fullScreenOpened"
        *ngIf="showValidationRemarksTab"
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined">
            assignment_turned_in
          </mat-icon>
          <span *ngIf="showTabTitle" i18n="@@general.validation.remarks.short">
            Val. Remarks
          </span>
        </a>
        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-inside-survey-validate-remarks
              *ngIf="survey"
              [remarks]="survey.validatorRemark"
            >
              <ng-container
                *ngIf="!showTabTitle"
                i18n="@@general.validation.remarks"
                >Validation Remarks
              </ng-container>
            </app-inside-survey-validate-remarks>
          </div>
        </ng-template>
      </li>

      <li
        [ngbNavItem]="tabConfig.tabs.addressInfo.id"
        [id]="tabConfig.tabs.addressInfo.id"
        [disabled]="tabConfig.tabs.addressInfo.disabled || fullScreenOpened"
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined"> room </mat-icon>
          <span *ngIf="showTabTitle" i18n="@@general.address"> Address </span>
        </a>
        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-inside-survey-address-info
              *ngIf="survey"
              [buildings]="survey.buildings"
              [survey]="survey"
              [isAuthCanWrite]="isAuthCanWrite"
              #insideSurveyComponent
            >
              <ng-container
                *ngIf="!showTabTitle"
                i18n="@@survey.inside.addressinfo.title.addressinfo"
              >
                Address info
              </ng-container>
            </app-inside-survey-address-info>
          </div>
        </ng-template>
      </li>

      <li
        [ngbNavItem]="tabConfig.tabs.photo.id"
        [id]="tabConfig.tabs.photo.id"
        [disabled]="tabConfig.tabs.photo.disabled || fullScreenOpened"
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined"> image </mat-icon>
          <mat-icon class="errorIcon" *ngIf="getErrors(tabConfig.tabs.photo.id)"
            >warning</mat-icon
          >
          <span *ngIf="showTabTitle" i18n="@@general.photo"> Photo </span>
        </a>

        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-inside-survey-photo
              *ngIf="survey"
              [survey]="survey"
              [isAuthCanWrite]="isAuthCanWrite"
              [editor]="editor"
              [camera]="camera"
              [cameraLayer]="cameraLayer"
              [viewerLayer]="viewerLayer"
              [editorLayer]="editorLayer"
              #insideSurveyComponent
            >
              <ng-container
                *ngIf="!showTabTitle"
                i18n="@@survey.inside.survey.photo.outside"
              >
                Outside photo info
              </ng-container>
            </app-inside-survey-photo>
          </div>
        </ng-template>
      </li>

      <li
        [ngbNavItem]="tabConfig.tabs.outsideTechnicalInfo.id"
        [id]="tabConfig.tabs.outsideTechnicalInfo.id"
        [disabled]="
          tabConfig.tabs.outsideTechnicalInfo.disabled || fullScreenOpened
        "
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined"> info </mat-icon>
          <mat-icon
            class="errorIcon"
            *ngIf="getErrors(tabConfig.tabs.outsideTechnicalInfo.id)"
            >warning</mat-icon
          >
          <span *ngIf="showTabTitle" i18n="@@survey.inside.outsideinfo">
            Outside info
          </span>
        </a>
        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-inside-survey-outside-technical-info
              *ngIf="survey"
              [isAuthCanWrite]="isAuthCanWrite"
              [surveyStatus]="survey.surveyStatus"
              [editor]="editor"
              [camera]="camera"
              [cameraLayer]="cameraLayer"
              [viewerLayer]="viewerLayer"
              [editorLayer]="editorLayer"
              [buildings]="survey.buildings"
              #insideSurveyComponent
            >
              <ng-container
                *ngIf="!showTabTitle"
                i18n="@@survey.inside.outside.technicalinfo.title"
                >Outside technical info</ng-container
              >
            </app-inside-survey-outside-technical-info>
          </div>
        </ng-template>
      </li>

      <li
        [ngbNavItem]="tabConfig.tabs.insideTechnicalInfo.id"
        [id]="tabConfig.tabs.insideTechnicalInfo.id"
        [disabled]="
          tabConfig.tabs.insideTechnicalInfo.disabled || fullScreenOpened
        "
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined">
            room_preferences
          </mat-icon>
          <mat-icon
            class="errorIcon"
            *ngIf="getErrors(tabConfig.tabs.insideTechnicalInfo.id)"
            >warning</mat-icon
          >
          <span
            *ngIf="showTabTitle"
            i18n="@@survey.inside.technicalinfo.inside"
          >
            Inside info
          </span>
        </a>
        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-inside-survey-inside-technical-info
              *ngIf="survey"
              [survey]="survey"
              [isAuthCanWrite]="isAuthCanWrite"
              [editor]="editor"
              [camera]="camera"
              [cameraLayer]="cameraLayer"
              [viewerLayer]="viewerLayer"
              [editorLayer]="editorLayer"
              #insideSurveyComponent
            >
              <ng-container
                *ngIf="!showTabTitle"
                i18n="
                  @@survey.inside.technicalinfo.inside.general.technicalinfo.title"
                >Inside technical info
              </ng-container>
            </app-inside-survey-inside-technical-info>
          </div>
        </ng-template>
      </li>

      <li
        [ngbNavItem]="tabConfig.tabs.cablingProposal.id"
        [id]="tabConfig.tabs.cablingProposal.id"
        [disabled]="tabConfig.tabs.cablingProposal.disabled || fullScreenOpened"
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined"> cable </mat-icon>
          <mat-icon
            class="errorIcon"
            *ngIf="getErrors(tabConfig.tabs.cablingProposal.id)"
            >warning</mat-icon
          >
          <span *ngIf="showTabTitle" i18n="@@survey.inside.cabling.proposal">
            Cabling
          </span>
        </a>
        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-inside-survey-cabling-proposal
              *ngIf="survey"
              [survey]="survey"
              [isAuthCanWrite]="isAuthCanWrite"
              [viewerLayer]="viewerLayer"
              [camera]="camera"
              [cameraLayer]="cameraLayer"
              #insideSurveyComponent
            >
              <ng-container
                *ngIf="!showTabTitle"
                i18n="@@survey.inside.cabling.proposal.title.cableproposal"
              >
                Cabling proposal
              </ng-container>
            </app-inside-survey-cabling-proposal>
          </div>
        </ng-template>
      </li>

      <li
        [ngbNavItem]="tabConfig.tabs.outsideUnits.id"
        [id]="tabConfig.tabs.outsideUnits.id"
        [disabled]="tabConfig.tabs.outsideUnits.disabled || fullScreenOpened"
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined"> home_work </mat-icon>
          <mat-icon
            class="errorIcon"
            *ngIf="getErrors(tabConfig.tabs.outsideUnits.id)"
            >warning</mat-icon
          >
          <span *ngIf="showTabTitle" i18n="@@general.outside.units">
            Outside units
          </span>
        </a>
        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-inside-survey-outside-units
              *ngIf="survey"
              [buildings]="survey.buildings"
              [isAuthCanWrite]="isAuthCanWrite"
              #insideSurveyComponent
            >
              <ng-container
                *ngIf="!showTabTitle"
                i18n="@@survey.inside.outside.units.tab.title"
                >Outside Units
              </ng-container>
            </app-inside-survey-outside-units>
          </div>
        </ng-template>
      </li>

      <li
        [ngbNavItem]="tabConfig.tabs.insideUnits.id"
        [id]="tabConfig.tabs.insideUnits.id"
        [disabled]="tabConfig.tabs.insideUnits.disabled || fullScreenOpened"
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined"> house_siding </mat-icon>
          <mat-icon
            class="errorIcon"
            *ngIf="getErrors(tabConfig.tabs.insideUnits.id)"
            >warning</mat-icon
          >
          <span *ngIf="showTabTitle" i18n="@@general.inside.units">
            Inside units
          </span>
        </a>
        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-inside-survey-inside-units
              *ngIf="survey"
              [insideSurveyId]="survey.id"
              [insideUnits]="survey.insideUnits"
              [isAuthCanWrite]="isAuthCanWrite"
              [buildings]="survey.buildings"
              #insideSurveyComponent
            >
              <ng-container
                *ngIf="!showTabTitle"
                i18n="@@survey.inside.inside.units.title"
                >Inside Units
              </ng-container>
            </app-inside-survey-inside-units>
          </div>
        </ng-template>
      </li>

      <li
        [ngbNavItem]="tabConfig.tabs.contactInfo.id"
        [id]="tabConfig.tabs.contactInfo.id"
        [disabled]="tabConfig.tabs.contactInfo.disabled || fullScreenOpened"
      >
        <a ngbNavLink>
          <mat-icon class="material-icons-outlined"> contact_phone </mat-icon>
          <span *ngIf="showTabTitle" i18n="@@general.contacts"> Contacts </span>
        </a>
        <ng-template ngbNavContent>
          <div class="survey-container">
            <app-inside-survey-contact-info
              *ngIf="survey"
              [survey]="survey"
              [isAuthCanWrite]="isAuthCanWrite"
              #insideSurveyComponent
            >
              <ng-container *ngIf="!showTabTitle" i18n="@@general.contactinfo"
                >Contact info
              </ng-container>
            </app-inside-survey-contact-info>
          </div>
        </ng-template>
      </li>

      <ng-container *ngIf="validateTabVisible">
        <li
          [ngbNavItem]="tabConfig.tabs.validate.id"
          [id]="tabConfig.tabs.validate.id"
          [disabled]="tabConfig.tabs.validate.disabled || fullScreenOpened"
        >
          <a ngbNavLink>
            <mat-icon class="material-icons-outlined"> verified </mat-icon>
            <span *ngIf="showTabTitle" i18n="@@general.validate">
              Validate
            </span>
          </a>
          <ng-template ngbNavContent>
            <div class="survey-container">
              <app-inside-survey-validate
                *ngIf="survey"
                [getValidationError]="getValidationError.bind(this)"
                [survey]="survey"
                #insideSurveyComponent
              >
                <ng-container *ngIf="!showTabTitle" i18n="@@general.validate">
                  Validate
                </ng-container>
              </app-inside-survey-validate>
            </div>
          </ng-template>
        </li>
      </ng-container>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
    <div class="hidden full-screen-overlay viewer" #viewerLayer>
      <div class="close-wrap">
        <div class="close-viewer" (click)="closeViewer()">
          <img src="assets/Keen&Wise_stop searching.png" />
        </div>
      </div>
    </div>
  </div>
</div>
<div class="hidden full-screen-overlay-camera" #cameraLayer>
  <app-camera #camera></app-camera>
</div>
